import { loadModules } from 'esri-loader';

loadModules([
  'esri/views/MapView',
  'esri/WebMap',
  'esri/widgets/Swipe',
  'esri/core/watchUtils',
  'esri/layers/GraphicsLayer',
]).then(initMap);

function initMap([MapView, WebMap, Swipe, watchUtils, GraphicsLayer]) {
  let maskLayer;
  let selectedGraphicsLayer;

  // The ArcGIS Map we are going to use on this page.
  const webmap = new WebMap({
    portalItem: {
      id: 'e59ecbdb094a4fed8541636245a1484c',
    },
  });
    // MapView object that gets attached to the page.
    // This is where all the map logic happens.
  const view = new MapView({
    container: 'viewDiv',
    map: webmap,
    ui: {
      components: ['attribution'],
    },
  });
  // The current state of the map and loading spinner
  // Helps to avoid calling functions when they aren't needed.
  const state = {
    isUpdating: true,
    spinnerVisible: true,
  };

  /**
     * When the map is NOT updating, hide the spinner.
     */
  watchUtils.whenFalse(view, 'updating', () => {
    state.isUpdating = false;

    // Give the state a chance to update again.
    // The map flickers between 'updating' and 'not updating',
    // so if we think we need to hide the spinner,
    // wait a bit and check again.
    setTimeout(() => {
      if (state.isUpdating) return;
      hideSpinner();
    }, 5000);

  });

  /**
     * When the map is updating, show the spinner.
     */
  watchUtils.whenTrue(view, 'updating', () => {
    state.isUpdating = true;
    if (state.spinnerVisible) return;
    showSpinner();
  });

  /**
     * Attach all the Swipe Layer JS and other interactions
     * This gets called ONCE when the map is 'ready',
     * but before the layers have loaded into view.
     * The 'updating' event will still occur while the rest
     * of the map data is being loaded.
     */
  view.when(() => {

    // remove the attribution from the bottom of the map
    view.ui.remove('attribution');

    // Disable the drag or pan functionality
    view.on('drag', (evt) => {
      // prevents panning with the mouse drag event
      evt.stopPropagation();
    });

    // Disable key map scrolling
    view.on('key-down', (evt) => {
      // prevents panning with the arrow keys
      const keyPressed = evt.key;
      if (keyPressed.slice(0, 5) === 'Arrow') {
        evt.stopPropagation();
      }
    });

    // Disable mouse scrolling
    view.on('mouse-wheel', (evt) => {
      evt.stopPropagation();
    });

    // Disable mouse scrolling
    view.on('double-click', (evt) => {
      evt.stopPropagation();
    });

    // add the swipe layer and setup the widget
    watchUtils.whenTrueOnce(webmap, 'loaded', () => {
      // get 2014 layer, always ID 0 (last layer in TOC)
      const oldLayer = webmap.layers.items[0];
      // get most recent layer, always ID 1 (middle layer in TOC)
      const newLayer = webmap.layers.items[1];
      // get query layer, always ID 2 in this map (top layer in TOC)
      maskLayer = webmap.layers.items[2];

      // setup swipe widget
      const swipe = new Swipe({
        leadingLayers: [oldLayer],
        trailingLayers: [newLayer],
        position: 50, // set position of widget to 50%
        view,
      });
        // add the swipe to the UI
      view.ui.add(swipe);
      // add selected graphics layer
      selectedGraphicsLayer = new GraphicsLayer();
      webmap.add(selectedGraphicsLayer);
      // select the initial Washington MSA
      newSelection('Washington-Arlington-Alexandria, DC-VA-MD-WV');
    });
  }, err => console.error(err));

  // The spinner element.
  const spinnerEl = document.querySelector('.loading');
  spinnerEl.classList.remove('show');

  document.querySelector('[data-js-change-city]').addEventListener('change', e => newSelection(e.target.value));
  /**
 * Show the loading spinner
 */
  function showSpinner() {
    spinnerEl.classList.add('show');
  }

  /**
 * Hide the loading spinner
 */
  function hideSpinner() {
    spinnerEl.classList.remove('show');
  }

  // zoom to the extent set as a bookmark in the webmap
  function newSelection(mapAreaLabel) {
    showSpinner();

    loadModules([
      'esri/tasks/support/Query',
    ]).then(([Query]) => {
      // selected symbol
      const sym = {
        type: 'simple-fill',
        style: 'none',
        outline: {
          width: 2,
        },
      };

      // clear previously selected feature
      selectedGraphicsLayer.removeAll();

      // query the mask layer for the selected MSA area
      const query = new Query();
      query.where = `cbsa_title = '${  mapAreaLabel  }'`;
      query.outSpatialReference = {
        wkid: 102100,
      };
      query.returnGeometry = true;
      query.outFields = ['*'];

      maskLayer.queryFeatures(query).then((results) => {
        const selectedMsa = results.features[0];

        // zoom to the new MSA
        view.extent = selectedMsa.geometry.extent.expand(1.5);
        selectedMsa.symbol = sym;

        // add the graphic to the selected graphic layer
        selectedGraphicsLayer.add(selectedMsa);
      });

      // set the definition query to only display the selected MSA
      maskLayer.definitionExpression = `cbsa_title <> '${  mapAreaLabel  }'`;
    });

    // Hide all area facts
    const areaFactElements = document.getElementsByClassName('areafacts');
    for (const i in areaFactElements) {
      if (areaFactElements.hasOwnProperty(i)) {
        areaFactElements[i].classList.remove('show');
      }
    }

    // Show area fact for selected area
    const metroSlug = convertToSlug(mapAreaLabel);
    const metros = document.getElementsByClassName(metroSlug);
    for (const i in metros) {
      if (metros.hasOwnProperty(i)) {
        metros[i].className = `${metros[i].className  } show`;
      }
    }
  }

  function convertToSlug(string) {
    return string
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '');
  }
}
